<template>
    <div>
        <div class="card card-shadow topic-result" v-for="conversation in filtered_items" :key="conversation.id">
            <div class="card-inner tw-flex">
                <a :href="'/profile/' + conversation.user.username">
                    <div class="profile-icon profile-icon-l hover:tw-opacity-75">
                        <img :src="conversation.user.avatar">
                    </div>
                </a>
                <div class="tw-flex-1 tw-pl-8 tw-pt-1">
                    <a :href="conversation.available ? '/conversations/' + conversation.slug : '#'">
                        <i class="far fa-lock tw-pr-1" v-if="!conversation.available"></i>
                        <h3 class="tw-text-gray-600 tw-font-semibold tw-text-lg tw-pb-2 tw-inline-block hover:tw-opacity-75">
                            {{ conversation.title }}
                        </h3>
                    </a>
                    <span class="tw-text-gray-300 tw-text-sm tw-block">
                    <a class="tw-text-gray-500 tw-font-semibold hover:tw-opacity-75" :href="'/profile/' + conversation.user.username">{{ conversation.user.first_name }} {{ conversation.user.last_name }}</a> {{ conversation.created_at | getDateHumanFormat }}
                </span>
                    <p class="tw-leading-relaxed tw-text-gray-500 text-base tw-pt-3" v-if="conversation.available" v-html="conversation.post.content.substring(0, 150)"></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    let _ = require('lodash');

    export default {
        name: 'SearchTopic',

        props: {
            items: {
                required: true,
            },
            extended: {
                required: true,
                default: false,
            },
            filter: {
                required: true,
            }
        },

        computed: {
            filtered_items() {
                if(this.extended) {
                    return this.filter === 'Nieuwste' ? _.orderBy(this.items, 'created_at', 'desc') : this.items;
                }

                return this.filter === 'Nieuwste' ? _.orderBy(this.items, 'created_at', 'desc').slice(0, 5) : this.items.slice(0, 5);
            }
        },

        filters: {
            getDateHumanFormat: function (date) {
                return moment(date).fromNow();
            }
        },
    }
</script>

<style lang="scss" scoped>
    .tw-text-gray-700 {
        color: #4a5568 !important;
    }

    .profile-icon {
        @apply tw-overflow-hidden tw-rounded #{!important};

        img {
            max-width: 50px;
        }
    }

    .card {
        @apply tw-rounded-none #{!important};

        &.card-shadow {
            @apply tw-shadow #{!important};
        }
    }
</style>